import resume from "../assets/pdf/Bulbul's-Resume.pdf";

export const headerData = {
  name: "Bulbul Tomar",
  title: "Front-End Developer",
  // Description:
  //   "Hey, there",
  resumePdf: resume,
};
